// src/errorBanner.svelte.ts

export type NotificationType = 'error' | 'success';

export let globalNotification = $state({ message: '', type: 'error' as NotificationType });

// Legacy alias — kept for backward compatibility
export let globalErrorBanner = globalNotification;

export function showGlobalError(message: string, durationMs = 4000) {
  showNotification(message, 'error', durationMs);
}

export function showGlobalSuccess(message: string, durationMs = 4000) {
  showNotification(message, 'success', durationMs);
}

export function showNotification(message: string, type: NotificationType = 'error', durationMs = 4000) {
  globalNotification.message = message;
  globalNotification.type = type;
  if (durationMs > 0) {
    setTimeout(() => {
      if (globalNotification.message === message) {
        globalNotification.message = '';
      }
    }, durationMs);
  }
}
